/* eslint-disable react/no-danger */
/* eslint-disable react/destructuring-assignment */
import Icon, { LeftOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { isEmpty } from "lodash";
import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import styled from "styled-components";
import EngagedAI from "../../../../static/EngagedAi_trans_bg.svg";
import MicIosIcon from "../../../icons/js/MicIosIcon";
import PaperClipIosIcon from "../../../icons/js/PaperClipIosIcon";
import StickerIosIcon from "../../../icons/js/StickerIosIcon";
import { isMarkdown } from "../../../utils/textHelpers";

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    height: 100% !important;
    border-radius: 20px !important;
    border: 2px solid !important;
  }
  .ant-modal-header {
    background: #f1f5f9 !important;
    border-radius: 20px 20px 0px 0px !important;
  }
  .ant-modal-body {
    padding: 0px !important;
    display: flex !important;
    flex-direction: column !important;
    height: calc(100% - 60px);
  }
`;

export const PreviewModal = props => {
  const { previewState, setpreviewState } = props;
  const { isEmail } = previewState;
  const { targetKey } = props.previewState;
  const PhoneTitle = () => {
    return (
      <div className="flex-row-centered justify-between">
        <LeftOutlined
          className="text-grey-800 cursor-pointer"
          onClick={() => setpreviewState({ visible: false, data: {} })}
        />
        <div className="flex-col-centered justify-center items-center">
          <Icon className="text-lg text-center" component={EngagedAI} alt="EngagedAi" />
          <span className="xs-400 text-black">EngagedAi</span>
        </div>
        <span />
      </div>
    );
  };
  const EmailTitle = () => {
    return (
      <div className="w-full flex-row-centered gap-1">
        {[1, 2, 3].map((item, index) => (
          <span key={index} className="bg-grey-400 block w-2 h-2 rounded-full" />
        ))}
      </div>
    );
  };

  const PhoneBody = () => {
    const rawContent = previewState?.data && previewState?.data[targetKey];

    const hasMarkdown = isMarkdown(rawContent);
    // Convert <br/> tags to newlines only for markdown parsing
    const markdownContent = rawContent?.replace(/<br\s*\/?>/gi, "\n");

    return (
      <>
        <div className="h-[calc(100%-40px)] overflow-y-auto pb-2">
          {!isEmpty(rawContent) && (
            <div className="received-message-container">
              {hasMarkdown ? (
                <div className="prose w-full">
                  <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdownContent}</ReactMarkdown>
                </div>
              ) : (
                <div className="w-full" dangerouslySetInnerHTML={{ __html: rawContent }} />
              )}
            </div>
          )}
        </div>
        <div className="bg-grey-150 h-[40px] rounded-b-[20px] flex-col-centered items-center border-0 border-solid border-b-[2px]">
          <div className="flex-row-centered w-full px-2 py-1 gap-1 justify-between">
            <PaperClipIosIcon />
            <div className="relative w-full flex-row-centered items-center">
              <input
                disabled
                className="w-full rounded-[15px] border-[1px] pl-1  border-solid"
                placeholder="Message"
              />
              <StickerIosIcon className="absolute right-2" />
            </div>
            <MicIosIcon />
          </div>
          <span className=" bg-grey-600 w-[120px] h-1 block rounded" />
        </div>
      </>
    );
  };

  const EmailBody = () => {
    const rawContent = previewState?.data && previewState?.data[targetKey];
    const hasMarkdown = isMarkdown(rawContent);
    // Convert <br/> tags to newlines only for markdown parsing
    const markdownContent = rawContent?.replace(/<br\s*\/?>/gi, "\n");

    return (
      <div className="w-full h-full">
        <div className="py-2 px-6 bg-grey-150 flex-col justify-start gap-1.5">
          <div className="flex-row-centered gap-2 items-center ">
            <span className="sm-600">To:</span>
          </div>
          <div className="flex-row-centered gap-2 items-center ">
            <span className="sm-600">From:</span>
            <span className="sm-400 text-grey-700">johncooper@gmail.com</span>
          </div>
          <div className="flex-row-centered gap-2 items-center ">
            <span className="sm-600">Subject:</span>
            <span className="sm-400 text-grey-700">{previewState.subject}</span>
            <span className="sm-400 text-grey-700">
              {targetKey === "afterHourEmailTemplateText"
                ? previewState?.data?.afterHourEmailSubjectText
                : previewState?.data?.emailSubjectText || ""}
            </span>
          </div>
        </div>
        <div className="py-2 px-6 h-[calc(100%-66px)] overflow-y-auto ">
          {hasMarkdown ? (
            <div className="prose w-full">
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdownContent}</ReactMarkdown>
            </div>
          ) : (
            <div className="w-full" dangerouslySetInnerHTML={{ __html: rawContent }} />
          )}
        </div>
      </div>
    );
  };
  const showEmail = ["emailTemplateText", "afterHourEmailTemplateText"].includes(targetKey);
  return (
    <ModalStyled
      closeIcon={null}
      title={showEmail ? <EmailTitle /> : <PhoneTitle />}
      open={previewState.visible}
      width={showEmail ? "800px" : "300px"}
      className={`${showEmail ? "h-[450px]" : "h-[600px]"}`}
      footer={null}
      onCancel={() =>
        setpreviewState({ ...previewState, visible: false, data: {}, isEmail: false })
      }
    >
      {showEmail ? <EmailBody /> : <PhoneBody />}
    </ModalStyled>
  );
};
